import { Permission } from './permissions';

export interface MenuPermissionViewModel {
  id: Permission;
  name: string;
}
